export default "__VITE_ASSET__B6LckR3V__"